export default function copyTextToClipboard(text, success, fail) {
  const textArea = document.createElement('textarea');
  textArea.style.position = 'absolute';
  textArea.style.top = 0;
  textArea.style.left = 0;
  textArea.style.width = '2em';
  textArea.style.height = '2em';
  textArea.style.opacity = 0;
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    const successful = document.execCommand('copy');
    if (successful) success();
    else fail();
  } catch (err) {
    fail();
  }
  document.body.removeChild(textArea);
}
